module.exports = __webpack_public_path__ + "img/horizontal_3_3_5012.398ba22d.png";